import Button from '@cobliteam/ui/components/Button';
import Dialog from '@cobliteam/ui/components/Dialog';

interface ConfirmationDialogProps {
  open: boolean;
  onOpenChange: (newOpen: boolean) => void;
  onConfirm: () => void;
}

const ConfirmationDialog = ({ open, onOpenChange, onConfirm }: ConfirmationDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <Dialog.Content>
      <Dialog.Header>
        <Dialog.Title>Associar motorista aos trechos</Dialog.Title>
        <Dialog.Close />
      </Dialog.Header>
      <Dialog.Body>
        <Dialog.Description className='mb-5'>
          O motorista será associado a todos os trechos selecionados impactando relatórios e nota do Ranking de condução. Deseja confirmar a alteração?
        </Dialog.Description>

        <Dialog.Footer className='pb-0'>
          <div className='flex flex-row justify-end gap-2'>
            <Dialog.Close asChild>
              <Button variant='ghost'>Cancelar</Button>
            </Dialog.Close>
            <Button onClick={onConfirm}>Confirmar</Button>
          </div>
        </Dialog.Footer>
      </Dialog.Body>
    </Dialog.Content>
  </Dialog>
);

export default ConfirmationDialog;
